import jwtDecode from "jwt-decode";
import { storage } from "./storage";

export const helpAuth = () => {
    let auth = false;
    let perfil = null;
    if(storage.get('token')) {
        //let payload = jwtDecode(window.localStorage.getItem('token'));
        perfil =  storage.get('perfilid');
        auth = true;
    }

    return {
        auth,
        perfil
    }
}